import { StreetSearchEnum } from "../enums/street-search-enum";
import { ArcGisStreetColumn } from "./arcgis-street-column.model";
export const StreetSearchColumnToArcGisColumnStreetsLookup = new Map([
    [StreetSearchEnum.Name, ArcGisStreetColumn.Name],
    [StreetSearchEnum.AlternativeName, ArcGisStreetColumn.AlternativeName],
    [StreetSearchEnum.Type, ArcGisStreetColumn.Type],
    [StreetSearchEnum.Ward, ArcGisStreetColumn.Ward],
]);
